module.exports = __webpack_public_path__ + "static/media/trending_up_black_24dp.7abbebb0.svg";